export default "__VITE_ASSET__ec412d16__"